import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import analyticsService from "../services/analyticsService";
import { getConnectorPrice } from "../utils/rateUtils";
import { buildStationPanel } from "../utils/stationPanel";
import ScreenLayout from "./ui/ScreenLayout";
import ConnectorCard from "./ui/ConnectorCard";
import LanguageSwitcher from "./ui/LanguageSwitcher";
import Button from "./ui/Button";
import Icon from "./ui/Icon";

// Écran 2a : la prise scannée est en charge. Deux profils arrivent ici : le client
// de cette recharge, orienté vers 2b, et un autre conducteur, qui doit revenir
// plus tard. Ni étapes ni paiement.
export default function ConnectorBusyComponent() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { evcpData, connector } = location.state || {};

  useEffect(() => {
    if (!evcpData || !connector) {
      navigate("/error", { state: { errorText: t("noBorneData") } });
      return;
    }
    analyticsService.pushEvent("connector_busy_viewed", {
      station_id: evcpData.reference,
      connector_id: connector.reference,
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!evcpData || !connector) return null;

  const findMyCharge = () => {
    analyticsService.pushEvent("resume_session_clicked", {
      station_id: evcpData.reference,
      connector_id: connector.reference,
    });
    navigate("/resume-session", { state: location.state });
  };

  return (
    <ScreenLayout
      headerRight={<LanguageSwitcher />}
      panel={buildStationPanel({ t, language: i18n.language, evcpData, connector, withStatus: true })}
    >
      <h1 className="mb-2 text-[28px] leading-9 tracking-[-.02em] font-bold md:text-[32px] md:leading-10">{t("busy.title")}</h1>
      <p className="mb-6 text-[15px] leading-6 text-qv-muted">{t("busy.subtitle")}</p>

      <ConnectorCard connector={connector} price={getConnectorPrice(connector, evcpData)} />

      <div className="mt-6 rounded-2xl bg-qv-brand-50 p-5">
        <p className="mb-1 text-base font-bold">{t("busy.yoursTitle")}</p>
        <p className="mb-4 text-sm leading-5 font-medium text-qv-muted">{t("busy.yoursText")}</p>
        <Button onClick={findMyCharge}>{t("busy.find")}</Button>
      </div>

      <p className="mt-5 flex gap-2.5 items-start text-sm leading-5 font-medium text-qv-muted">
        <Icon name="clock-circle-linear" size={20} className="text-qv-brand" />
        {t("busy.later")}
      </p>
    </ScreenLayout>
  );
}
